import { render, staticRenderFns } from "./DigitalLibraryForm.vue?vue&type=template&id=39a8b201&"
import script from "./DigitalLibraryForm.vue?vue&type=script&lang=js&"
export * from "./DigitalLibraryForm.vue?vue&type=script&lang=js&"
import style0 from "./DigitalLibraryForm.vue?vue&type=style&index=0&id=39a8b201&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports